import { render } from "./mountingsSell.vue?vue&type=template&id=7250043b&scoped=true&ts=true"
import script from "./mountingsSell.vue?vue&type=script&lang=ts"
export * from "./mountingsSell.vue?vue&type=script&lang=ts"

import "./mountingsSell.vue?vue&type=style&index=0&id=7250043b&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7250043b"]])

export default __exports__